import React, { createContext, useState, useEffect, useContext, useRef } from 'react';
import { PropTypes } from 'prop-types';
import { Client as ConversationsClient } from '@twilio/conversations';
import { MessagingTokenContext } from './MessagingTokenProvider';

export const ConversationsClientContext = createContext();

const ConversationsClientProvider = ({ children }) => {
    const [conversationsClient, setConversationsClient] = useState();
    const [status, setStatus] = useState();
    const [statusString, setStatusString] = useState();
    const [isReady, setIsReady] = useState(false);
    const { accessToken } = useContext(MessagingTokenContext);

    const handleStateChange = state => {
        console.log({ state });
        if (state === 'connecting') {
            setStatusString('Connecting...');
            setStatus('default');
        }
        if (state === 'connected') {
            setStatusString('You are connected.');
            setStatus('success');
            setIsReady(true);
        }
        if (state === 'disconnecting') {
            setStatusString('Disconnecting...');
            setIsReady(false);
            setStatus('default');
        }

        if (state === 'disconnected') {
            setStatusString('Disconnected.');
            setIsReady(false);
            setStatus('warning');
        }
        if (state === 'denied') {
            setStatusString('Failed to connect.');
            setIsReady(false);
            setStatus('error');
        }
    };

    // the creation of the client triggers the loading of the conversations in ConversationsProvider
    useEffect(() => {
        if (!accessToken) return;
        (async () => {
            const client = await ConversationsClient.create(accessToken);
            client.on('connectionStateChanged', handleStateChange);
            setConversationsClient(client);
        })();
    }, [accessToken]);

    return (
        <ConversationsClientContext.Provider value={{ conversationsClient, status, statusString, isReady }}>
            {children}
        </ConversationsClientContext.Provider>
    );
};

ConversationsClientProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

export default ConversationsClientProvider;
